
const hostname = window.location.hostname
const protocal = window.location.protocol

export const BASE_URL = `https://lcen.xiaote.net/`




// WEBPACK FOOTER //
// ./src/config/config.js